(() => {
  const root = document.querySelector('[data-ms-root]');
  if (!root) return;

  const mobileMenuButton = root.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = root.querySelector('[data-mobile-menu]');
  const closeMobileMenu = () => {
    if (!mobileMenu || !mobileMenuButton) return;
    mobileMenu.classList.remove('is-open');
    mobileMenuButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-menu-open');
  };

  if (mobileMenuButton && mobileMenu) {
    mobileMenuButton.addEventListener('click', () => {
      const willOpen = !mobileMenu.classList.contains('is-open');
      mobileMenu.classList.toggle('is-open', willOpen);
      mobileMenuButton.setAttribute('aria-expanded', String(willOpen));
      document.body.classList.toggle('mobile-menu-open', willOpen);
    });
    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMobileMenu));
    window.addEventListener('resize', () => {
      if (window.innerWidth > 900) closeMobileMenu();
    }, { passive: true });
  }
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMobileMenu();
  });

  let refreshShopLanguage = () => {};

  const applyLanguage = (lang) => {
    const next = lang === 'tr' ? 'tr' : 'en';
    root.querySelectorAll('[data-en][data-tr]').forEach((element) => {
      const value = element.dataset[next];
      if (value == null) return;
      if (element.matches('input, textarea')) element.placeholder = value;
      else element.textContent = value;
    });
    root.querySelectorAll('[data-lang-button]').forEach((button) => {
      const active = button.dataset.langButton === next;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    document.documentElement.lang = next;
    try { localStorage.setItem('malikispace-language', next); } catch (_) {}
    refreshShopLanguage();
  };

  const productDialog = root.querySelector('[data-product-dialog]');
  const productCards = root.querySelectorAll('[data-shop-product]');
  const filterButtons = root.querySelectorAll('[data-store-filter]');
  const productTotal = root.querySelector('[data-demo-product-total]');
  const dialogImage = root.querySelector('[data-product-dialog-image]');
  const dialogTitle = root.querySelector('[data-product-dialog-title]');
  const dialogPrice = root.querySelector('[data-product-dialog-price]');
  const dialogDescription = root.querySelector('[data-product-dialog-description]');
  const addButton = root.querySelector('[data-demo-add]');
  const bagButton = root.querySelector('[data-demo-bag]');
  const bagDrawer = root.querySelector('[data-demo-bag-drawer]');
  const bagBackdrop = root.querySelector('[data-demo-bag-backdrop]');
  const bagList = root.querySelector('[data-demo-bag-list]');
  const quantityValue = root.querySelector('[data-demo-quantity-value]');
  const quantityButtons = root.querySelectorAll('[data-demo-quantity]');
  const bagCounts = root.querySelectorAll('[data-demo-bag-count], [data-demo-drawer-count]');
  const sampleBag = [];
  let activeProduct = null;
  let activeQuantity = 1;

  if (productDialog && productCards.length) {
    const currentLanguage = () => document.documentElement.lang === 'tr' ? 'tr' : 'en';
    const syncOverlayState = () => {
      const dialogOpen = productDialog.open;
      const drawerOpen = bagDrawer?.classList.contains('is-open');
      document.body.classList.toggle('demo-overlay-open', Boolean(dialogOpen || drawerOpen));
    };
    const closeDialog = () => {
      if (productDialog.open) productDialog.close();
      syncOverlayState();
    };
    const openDrawer = () => {
      bagDrawer?.classList.add('is-open');
      bagBackdrop?.classList.add('is-open');
      bagDrawer?.setAttribute('aria-hidden', 'false');
      bagButton?.setAttribute('aria-expanded', 'true');
      syncOverlayState();
    };
    const closeDrawer = () => {
      bagDrawer?.classList.remove('is-open');
      bagBackdrop?.classList.remove('is-open');
      bagDrawer?.setAttribute('aria-hidden', 'true');
      bagButton?.setAttribute('aria-expanded', 'false');
      syncOverlayState();
    };
    const renderBag = () => {
      const totalQuantity = sampleBag.reduce((sum, item) => sum + item.quantity, 0);
      bagCounts.forEach((count) => { count.textContent = String(totalQuantity); });
      if (!bagList) return;
      bagList.replaceChildren();
      if (!sampleBag.length) {
        const empty = document.createElement('p');
        empty.textContent = currentLanguage() === 'tr'
          ? 'Örnek sepetin boş. Bir ürünü açıp buraya ekleyebilirsin.'
          : 'Your sample bag is empty. Open a product and add it here.';
        bagList.append(empty);
        return;
      }
      sampleBag.forEach((product, index) => {
        const item = document.createElement('article');
        item.className = 'demo-bag-item';
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        const copy = document.createElement('div');
        const title = document.createElement('h3');
        title.textContent = product.title;
        const price = document.createElement('span');
        price.textContent = `${product.price} · ×${product.quantity}`;
        copy.append(title, price);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('aria-label', 'Remove');
        remove.textContent = '×';
        remove.addEventListener('click', () => {
          sampleBag.splice(index, 1);
          renderBag();
        });
        item.append(image, copy, remove);
        bagList.append(item);
      });
    };
    const paintProduct = () => {
      if (!activeProduct) return;
      dialogImage.src = activeProduct.image;
      dialogImage.alt = activeProduct.title;
      dialogTitle.textContent = activeProduct.title;
      dialogPrice.textContent = activeProduct.price;
      dialogDescription.textContent = currentLanguage() === 'tr' ? activeProduct.descriptionTr : activeProduct.descriptionEn;
      if (quantityValue) quantityValue.textContent = String(activeQuantity);
    };

    refreshShopLanguage = () => {
      paintProduct();
      renderBag();
    };

    productCards.forEach((card) => {
      card.addEventListener('click', () => {
        activeQuantity = 1;
        activeProduct = {
          title: card.dataset.productTitle,
          price: card.dataset.productPrice,
          image: card.dataset.productImage,
          descriptionEn: card.dataset.productDescEn,
          descriptionTr: card.dataset.productDescTr
        };
        paintProduct();
        productDialog.showModal();
        syncOverlayState();
      });
    });
    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.storeFilter;
        let visibleCount = 0;
        productCards.forEach((card) => {
          const visible = filter === 'all' || card.dataset.productCategory === filter;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        filterButtons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        if (productTotal) productTotal.textContent = String(visibleCount);
      });
    });
    quantityButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const change = Number(button.dataset.demoQuantity) || 0;
        activeQuantity = Math.min(9, Math.max(1, activeQuantity + change));
        if (quantityValue) quantityValue.textContent = String(activeQuantity);
      });
    });
    root.querySelector('[data-product-close]')?.addEventListener('click', closeDialog);
    productDialog.addEventListener('click', (event) => {
      if (event.target === productDialog) closeDialog();
    });
    productDialog.addEventListener('close', () => {
      syncOverlayState();
    });
    addButton?.addEventListener('click', () => {
      if (activeProduct) {
        const existing = sampleBag.find((item) => item.title === activeProduct.title);
        if (existing) existing.quantity = Math.min(99, existing.quantity + activeQuantity);
        else sampleBag.push({ ...activeProduct, quantity: activeQuantity });
      }
      renderBag();
      closeDialog();
      openDrawer();
    });
    bagButton?.addEventListener('click', openDrawer);
    root.querySelector('[data-demo-bag-close]')?.addEventListener('click', closeDrawer);
    bagBackdrop?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (bagDrawer?.classList.contains('is-open')) closeDrawer();
    });
    renderBag();
  }

  root.querySelectorAll('[data-lang-button]').forEach((button) => {
    button.addEventListener('click', () => applyLanguage(button.dataset.langButton));
  });

  let saved = 'en';
  try { saved = localStorage.getItem('malikispace-language') || 'en'; } catch (_) {}
  applyLanguage(saved);
})();
